<template>
    <div class="arrow">
        <font-awesome-icon :icon="rightIcon" />
    </div>
</template>

<script>
    import { faLongArrowRight }  from '@fortawesome/pro-light-svg-icons/faLongArrowRight'

    export default {
        name: "Arrow",
        props: {
            color: {
                type: String,
                default: 'white-stroke'
            },
            width: {
                type: Number,
                default: 27
            }
        },
        computed: {
            rightIcon() {
                return faLongArrowRight
            }
        }
    }
</script>

<style lang="scss" scoped>
    .arrow {
        display: flex;
        align-items: center;
    }
</style>